"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberValid = void 0;
const numberValid = (number) => {
    if (typeof number === 'number')
        return true;
    if (typeof number === 'string') {
        return /\d|\./g.test(number) && !Number.isNaN(parseFloat(number));
    }
    return false;
};
exports.numberValid = numberValid;
